import { render, staticRenderFns } from "./image-preview.vue?vue&type=template&id=989740b8&scoped=true"
import script from "./image-preview.vue?vue&type=script&lang=js"
export * from "./image-preview.vue?vue&type=script&lang=js"
import style0 from "./image-preview.vue?vue&type=style&index=0&id=989740b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989740b8",
  null
  
)

export default component.exports